import { Module } from '@nestjs/common';
import { MailModule } from 'src/mail/mail.module';
import { TwilioModule } from 'src/twilio/twilio.module';
import { NotificacionesService } from './notificaciones.service';
import { NotificacionesController } from './notificaciones.controller';

@Module({
  imports: [MailModule, TwilioModule],
  controllers: [NotificacionesController],
  providers: [NotificacionesService],
  exports: [NotificacionesService],
})
export class NotificacionesModule {}
